import ProjectAdminModal from './ProjectAdminModal';

export default ProjectAdminModal;
